module.exports = __webpack_public_path__ + "static/img/mainintrodution.e217027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/mainintrodution.jpg
// module id = c90Q
// module chunks = 10